import { SORT_DIRECTIONS } from '@linearb/linui-common';
import { useSearchParams } from 'react-router-dom';

export const SORT_OPTIONS = [
  { value: 'total_run_in_period', label: 'Run Count' },
  { value: 'automation_name', label: 'Alphabetical' },
  { value: 'first_run_time', label: 'Creation Date' }
];

export function useFilters() {
  const [params, setParam] = useSearchParams();

  const search = params.get('search') ?? '';
  const sort = params.get('sort') || SORT_OPTIONS[0].value;
  const sortType = params.get('sort_type') || SORT_DIRECTIONS.DESC;
  const period = params.get('period');

  return {
    filters: {
      search,
      sort,
      sortType,
      period
    },
    setFilter(filter, value) {
      setParam(oldParams => {
        oldParams.set(filter, value);
        return oldParams;
      });
    },
    deleteFilter(filter) {
      setParam(oldParams => {
        oldParams.delete(filter);
        return oldParams;
      });
    }
  };
}
